/**
 * Route utilities for handling navigation and route preservation
 */

/**
 * Save the current route to localStorage for later restoration
 */
export const saveIntendedRoute = (route: string): void => {
  try {
    localStorage.setItem('intended_route', route);
  } catch (error) {
    console.warn('Failed to save intended route:', error);
  }
};

/**
 * Get and clear the saved intended route
 */
export const getAndClearIntendedRoute = (): string | null => {
  try {
    const route = localStorage.getItem('intended_route');
    if (route) {
      localStorage.removeItem('intended_route');
    }
    return route;
  } catch (error) {
    console.warn('Failed to get intended route:', error);
    return null;
  }
};

/**
 * Check if a route requires authentication
 */
export const isProtectedRoute = (pathname: string): boolean => {
  const protectedRoutes = [
    '/dashboard',
    '/alpaca-keys',
    '/trade-history',
    '/settings',
    '/admin',
    '/system-logs',
    '/top50-selector', // Legacy route, redirects to /trading-universe
    '/earnings-watchlist',
    '/qa-results'
  ];
  
  return protectedRoutes.some(route => pathname.startsWith(route));
};

/**
 * Get the default route for a user based on their role
 */
export const getDefaultRoute = (userRole: string): string => {
  if (userRole === 'ADMIN') {
    return '/admin';
  }
  return '/dashboard';
};
